import '../../sass/general/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect} from 'react'
import { ReactComponent as CleanTalkLogo } from '../../svg/filled/cleantalklogo.svg';
import { ReactComponent as CleanTalkLogoText } from '../../svg/cleantalklogo-text.svg';
import { connect } from 'react-redux';
import { saveKey, setAccountFormIsVisible } from '../../redux/actions/pagesActions'
import { ToastContainer, Bounce } from 'react-toastify';
import Footer from '../../components/Footer/Footer';
import useQuery from '../../hooks/useQuery';
import { accountFormIsVisible } from '../../redux/selectors/pagesSelectors'
import ReactModal from "react-modal";
import RegisterForm from "../../components/Registraion/RegisterForm";
import { Outlet } from 'react-router-dom'
import { useHeaderSlot } from '../../context/HeaderSlotContext'

function Main({
    registrationFormIsVisible,
    setFormIsVisible,
    saveKey
}) {

    const query = useQuery();

    useEffect(() => {
        const userToken = query.get('user_token') ?? null;
        const paymentPageToken = query.get('payment_page_token') ?? null;
        if (userToken || paymentPageToken) {
            saveKey(userToken, paymentPageToken);
        }
    }, [query, saveKey]);

    const { headerContent } = useHeaderSlot();

    return (
        <>
            {/* Header */}
            <header className="header">
                <div className="container mobile-side-gap header__container">
                    <a className="header__logo-link" href="https://cleantalk.org/my">
                        <CleanTalkLogo className="header__logo-icon" />
                        <CleanTalkLogoText className="header__logo-text icon" />
                    </a>

                    {/* Dynamic header content */}
                    {headerContent || ""}
                </div>
            </header>

            {/* Main content */}
            <main className="main">
                <Outlet />
            </main>

            {/* Footer */}
            <Footer />

            {/* Toast notifications */}
            <ToastContainer
                position="bottom-center"
                autoClose={8000}
                hideProgressBar
                stacked={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                theme="light"
                transition={Bounce}
            />

            {/* Registration modal */}
            <ReactModal
                isOpen={registrationFormIsVisible}
                contentLabel="Registration form"
                onRequestClose={() => setFormIsVisible(false)}
                shouldCloseOnOverlayClick={false}
                portalClassName="modal__container"
                overlayClassName="modal__overlay"
                className="modal__content"
                bodyOpenClassName="body--modal-opened"
                htmlOpenClassName="html--modal-opened"
                ariaHideApp={false}
                closeTimeoutMS={500}
            >
                <RegisterForm />
            </ReactModal>
        </>
    );

}

const mapStateToProps = (state) => ({
    registrationFormIsVisible: accountFormIsVisible(state),
});

const mapDispatchToProps = (dispatch) => ({
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    saveKey: (userToken, paymentPageToken) => dispatch(saveKey(userToken, paymentPageToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
